// angular
import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CoreService } from '../../../core/core.service';
import { AppService } from '../../../app.service';
import { MeDynamicReportService } from '../dynamic-report.service';

@Component({
    selector: 'me-dynamic-patient-cluster',
    templateUrl: './cluster.component.html',
    styleUrls: ['./cluster.component.scss'],
    providers: [MeDynamicReportService]
})

export class MeDynamicClusterComponent implements OnInit {
    data: any;
    items = [];
    url = 'dynamic-report/clusters/';
    chartData : any;
    slug = '';

    constructor(
        public translate: TranslateService,
        public appService: AppService,
        public router: Router,
        public route: ActivatedRoute,
        public coreService: CoreService,
        public meDynamicReportService: MeDynamicReportService
    ) {
       
    }

    ngOnInit() {
        this.appService.isLoading = true;
        this.route.params.subscribe(params => {
            this.slug = params['slug'];
            this.url = this.url + this.slug;
            this.getClusterContent();
        })

        this.translate.onLangChange.subscribe(value => {
            this.getClusterContent();
        });
    }

    getClusterContent() {
        this.appService.getStoryBlokDataForClinic(this.url).subscribe(res => {
            let contents = res['story']['content'] ?? [];
            this.data = contents;
            this.getDynamicReportData(res['story']['uuid']);
        });
    }

    getDynamicReportData(id) {
        this.appService.isLoading = true;
        this.chartData = null;
        this.meDynamicReportService.getDynamicReportCluster(id).subscribe(res => {
            this.chartData = res['data'];
            this.appService.isLoading = false;
        });
    }


    activeCluster(id) {
        this.router.navigate(['me/dynamic-report/clusters/' + this.slug + '/' + id]);
    }

}
